import React from 'react';

import { extendVariants, Avatar as StyledAvatar, Tooltip } from '@cavela/ui';

const Avatar = extendVariants(StyledAvatar, {
  variants: {
    color: {
      violet: {
        base: 'bg-[#7048E8] text-white'
      },
      transparent: {
        base: 'bg-transparent text-white'
      }
    },
    size: {
      lg: {
        base: 'size-9 text-[22px] font-semibold min-h-[36px] min-w-[36px]'
      },
      md: {
        base: 'size-7 text-[16px] font-semibold'
      },
      sm: {
        base: 'w-[22px] h-[22px] text-[12px] font-semibold'
      },
      xs: {
        base: 'w-[20px] h-[20px] text-[12px] font-semibold'
      },
      xl: {
        base: 'size-24 text-[60px] font-semibold'
      }
    }
  },
  defaultVariants: {
    color: 'violet',
    size: 'lg',
    radius: 'full'
  }
});

interface UserAvatarProps {
  size?: 'lg' | 'md' | 'sm' | 'xs' | undefined | 'xl';
  name: string;
  image?: string;
  radius?: 'full' | 'lg' | 'md' | 'sm' | 'none';
  disableAnimation?: boolean;
  className?: string;
  withTooltip?: boolean;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  size,
  name,
  image,
  radius,
  disableAnimation,
  className,
  withTooltip
}) => {
  if (withTooltip) {
    return (
      <Tooltip closeDelay={0} content={name}>
        <Avatar
          classNames={{ base: ['uppercase z-[20]', className] }}
          size={size}
          name={name?.charAt(0) ?? ''}
          src={image}
          color={image ? 'transparent' : 'violet'}
          radius={radius}
          disableAnimation={disableAnimation}
        />
      </Tooltip>
    );
  }

  return (
    <Avatar
      classNames={{ base: ['uppercase z-[20]', className] }}
      size={size}
      name={name?.charAt(0) ?? ''}
      src={image}
      color={image ? 'transparent' : 'violet'}
      radius={radius}
      disableAnimation={disableAnimation}
    />
  );
};

export default UserAvatar;
